import { createSlice } from '@reduxjs/toolkit';

const initialTargetingBrandsModelsState = {
  type: 'all_brands',
  // type: 'specific_brands_models',
  dataIsChanged: true,
};

const targetingBrandsModelsSlice = createSlice({
  name: 'targetingBrandsModels',
  initialState: initialTargetingBrandsModelsState,
  reducers: {
    changeBrandsModelsTargetingType: (state, action) => {
      state.type = action.payload;
    },
    changeFlag: (state, action) => {
      state.dataIsChanged = action.payload;
    },
    restoreInitialState: () => initialTargetingBrandsModelsState,
  },
});

export const targetingBrandsModelsActions = targetingBrandsModelsSlice.actions;
export default targetingBrandsModelsSlice.reducer;
